export default __webpack_public_path__ + "static/media/getReadyForExam_img.ab2ec8ae.png";